import {
    Box,
    Button,
    Divider,
    Grid,
    IconButton,
    MenuItem,
    Select,
    TextField,
    Typography,
    Autocomplete,
    CircularProgress,
    createFilterOptions,
    Paper,
    InputAdornment,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import { Add, Clear, DeleteOutlined, EditOutlined } from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../../Masters/dataConfig";
import moment from "moment";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import {
    DatePicker,
    LocalizationProvider,
} from "@mui/x-date-pickers";
import NormalTable from "../../../Component/NormalTable";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { fromUTC, getCurrentInTimeZone, getDateWithOutUTC, toUTC } from "../../../utils/dateUtil";

const IssueModal = ({ mode, handleCloseClick, editData }) => {
    const [woData, setWOData] = useState([]);
    const [woSel,setWOSel]=useState("")
    const [selectedWorkOrder, setSelectedWorkOrder] = useState(null);
    const [assetData, setAssetData] = useState([]);
    const [assetSel,setAssetSel]=useState("")
    const [partAssignType, setPartAssignType] = useState("Unassigned");
    const [issueItem,setIssueItem]=useState({
        partId: null,
        stockRoomId: null,
        stockRoomRowId: null,
        stockRoomRowAisleId: null,
        stockRoomRowBinId: null,
        quantity: 0,
        unitCost: 0,
        lineCost: 0,
        issuedDate:getCurrentInTimeZone().dayjsObject,
        stockAisle:[],
        stockRow:[],
        stockBin:[],
        stockRoom:[]
    })
    const [maxQuantity,setMaxQuantity]=useState("")

    const [partData, setPartData] = useState([]);
    const [workOrderParts, setWorkOrderParts] = useState([]);
    const [reservedParts, setReservedParts] = useState([]);
    const [loadingParts, setLoadingParts] = useState(false);
    const [issuePerson,setIssuePerson]=useState("")
    const [personData,setPersonData]=useState([])


    const [addIssue, setAddIssue] = useState([]);
    const [partSelect, setPartSel] = useState("");
    const [srSelect, setSRSel] = useState("");
    const [srAisleSelect, setSRAisleSel] = useState("");
    const [srRowSelect, setSRRowSel] = useState("");
    const [srBinSelect, setSRBinSel] = useState("");


    const [loading, setLoading] = useState(false);
    const siteInfoDetail=useSelector(state=>state.auth.loginInfo)

    useEffect(() => {
        getData()

    }, []);

    const getData=async()=>{
        setLoading(true);
       fetchPartall()
        const link = masterAPI["workOrder"].link;
        await axiosPrivate
            .get(`${link}`)
            .then((res) => {
                setLoading(false);
                setWOData(res.data.result);
            })
            .catch((e) => {
                setWOData([])
                setLoading(false)
                console.log(e, "create wo");
            });

       
          const personLink=masterAPI["person"].link
             await axiosPrivate.get(`${personLink}`).then(res=>{
               setPersonData(res.data.result)
              }).catch(e=>{
               setPersonData([])
               console.log(e,'error')
              })
             

        const assetlink = masterAPI["assets"].link;
        await axiosPrivate
            .get(`${assetlink}`)
            .then((res) => {
                setLoading(false);
                setAssetData(res.data.result);
            })
            .catch((e) => {
                setLoading(false)
                setAssetData([])
                console.log(e, "create asset");
            });


    }
    const fetchPartall=()=>{
         const partLink=masterAPI["inventory"].getAll
         axiosPrivate.get(`${partLink}`).then(res=>{
            console.log(res,"partLink")
            const partIdFilt=[]
            const partFilter=[]
            for(let i=0;res.data.result.length>i;i++){
                if(!partIdFilt.includes(res.data.result[i].partId)){
                    partIdFilt.push(res.data.result[i].partId)
                    partFilter.push(res.data.result[i])
                }
            }
            console.log(partFilter)
            setPartData(partFilter)
        }).catch(e=>{
            setPartData([])
            console.log(e,"error part Data")
        })

    }

    const fetchWorkOrderParts = async (workOrderId) => {
        setLoadingParts(true);
        setWorkOrderParts([]);

        try {
            const response = await axiosPrivate.get(
                `${masterAPI?.["workOrder"]?.getWOPartByWOId}/${workOrderId}`
            );

            if (response.data.statusCode === 200) {
                setWorkOrderParts(response.data.result);
            }
        } catch (error) {
            console.log(error, "error fetching work order parts");
            setWorkOrderParts([]);
        } finally {
            setLoadingParts(false);
        }
    };

    const fetchReservedParts = async (workOrderId) => {
        setLoadingParts(true);
        setReservedParts([]);
        try {
            const response = await axiosPrivate.get(
                `${masterAPI.partsReservation.getByWorkOrderId}/${workOrderId}`
            );

            if (response.data.statusCode === 200) {
                console.log(response.data.result, "reserved parts response");
                setReservedParts(response.data.result[0]?.partsReservationItemsList);
            }
        } catch (error) {
            console.log(error, "error fetching reserved parts");
            setReservedParts([]);
        } finally {
            setLoadingParts(false);
        }
    };

    const defaultFilterOptions = createFilterOptions();

    const filterOptions = (options, state) => {
        return defaultFilterOptions(options, state);
    };
    const CustomPaper = (props) => {
        return <Paper elevation={8} {...props} />;
    };

    const initialValue = {

        workOrderId: mode === "Edit" ? editData.workOrderId : null,
        assetId: mode === "Edit" ? editData.assetId : null,
        issuedToPersonId: mode === "Edit" ? editData.issuedToPersonId : null,
        issuedDate: mode === "Edit" ? editData.issuedDate!==null&&editData.issuedDate!==undefined?fromUTC(editData.issuedDate):getCurrentInTimeZone().dayjsObject : getCurrentInTimeZone().dayjsObject,
        glCreditAccount: mode === "Edit" ? editData.glCreditAccount : "",
        glDebitAccount:mode === "Edit" ? editData.glDebitAccount : "",

    };

    const onSubmit = async(value) => {
        console.log(value);
        setLoading(true);
        const createLink = masterAPI["issue"].create;
        const updateLink = masterAPI["issue"].update;
        if (mode === "Create") {
            const postData={
                ...value,
                issuedItemsList:addIssue
            }
            console.log(postData)
            await axiosPrivate
                .post(`${createLink}`, postData)
                .then((res) => {
                    console.log(res.data);
                    setLoading(false);
                    handleCloseClick();
                })
                .catch((e) => {
                    setLoading(false);
                    console.log(e, "create Issue");
                });
        } else {
            const updateAC = {
                id: editData.id,
                ...value,
            };
            await axiosPrivate
                .put(`${updateLink}`, updateAC)
                .then((res) => {
                    console.log(res.data);
                    setLoading(false);
                    handleCloseClick();
                })
                .catch((e) => {
                    setLoading(false);
                    console.log(e, "update Issue");
                });
        }
    };

    const handlePart=async(value)=>{
        const srLink=masterAPI["selectList"].stockRoomByPart
        await axiosPrivate.get(`${srLink}/${value.partId}`).then(res=>{
            const storeRI={
                ...issueItem,
                partId:value.partId,
                partCode:value.code,
                partName:value.partName,
                stockRoom:res.data

            }
            setIssueItem(storeRI)
        }).catch(e=>{
            console.log(e)
        })
    }

    const handleAssignedPart = async(value) => {
        const srLink=masterAPI["selectList"].stockRoomByPart
        await axiosPrivate.get(`${srLink}/${value.partId}`).then(res=>{
            const storeRI={
                ...issueItem,
                partId:value.partId,
                workOrderPartsId: value.id,
                partCode:value.code || "",
                partName:value.partName,
                stockRoom:res.data
            }
            setIssueItem(storeRI)
        }).catch(e=>{
            console.log(e)
            const storeRI={
                ...issueItem,
                partId:value.partId,
                workOrderPartsId: value.id,
                partCode:value.code || "",
                partName:value.partName,
                stockRoom:[]
            }
            setIssueItem(storeRI)
        })
    }

    const handleReservedPart = async(value) => {
        const srLink=masterAPI["selectList"].stockRoomByPart
        await axiosPrivate.get(`${srLink}/${value.partId}`).then(async res=>{
            const storeRI={
                ...issueItem,
                partId:value.partId,
                partsReservationId: value.id,
                partCode:value.partCode || "",
                partName:value.partName,
                stockRoomId: value.stockRoomId,
                stockRoomName: value.stockRoomName,
                quantity: value.quantity,
                stockRoom:res.data
            }
        
           
            setIssueItem(storeRI)
            if(value.stockRoomId && value.stockRoomName) {
                setSRSel(value.stockRoomName);

                const getAisleLink=masterAPI["selectList"].aisleByPartAndRoom
                await axiosPrivate.get(`${getAisleLink}/${value.partId}/${value.stockRoomId}`).then(aisleRes=>{
                    const storeWithAisle={
                        ...storeRI,
                        stockAisle:aisleRes.data
                    }
                    setIssueItem(storeWithAisle)
                }).catch(e=>{
                    console.log(e,"error fetching aisle")
                })
            }
        }).catch(async e=>{
            console.log(e)
            const storeRI={
                ...issueItem,
                partId:value.partId,
                partsReservationId: value.id,
                partCode:value.partCode || "",
                partName:value.partName,
                stockRoomId: value.stockRoomId,
                stockRoomName: value.stockRoomName,
                quantity: value.quantity,
                stockRoom:[]
            }
            setIssueItem(storeRI)
            if(value.stockRoomId && value.stockRoomName) {
                setSRSel(value.stockRoomName);

                const getAisleLink=masterAPI["selectList"].aisleByPartAndRoom
                await axiosPrivate.get(`${getAisleLink}/${value.partId}/${value.stockRoomId}`).then(aisleRes=>{
                    const storeWithAisle={
                        ...storeRI,
                        stockAisle:aisleRes.data
                    }
                    setIssueItem(storeWithAisle)
                }).catch(e=>{
                    console.log(e,"error fetching aisle")
                })
            }
        })
    }

    const handleAddIssue=(e)=>{
        const {name,value}=e.target
         if (value === "" || Number(value) <= Number(maxQuantity)||partAssignType!=="Reserved") {
         if(name==="unitCost"){
            const storeRI={
                ...issueItem,
                [name]:value,
                lineCost:issueItem.quantity*value

            }
            setIssueItem(storeRI)
        }else{
            const storeRI={
                ...issueItem,
                [name]:value

            }
            setIssueItem(storeRI)
        }
  }else{
    toast.warn(`Max Qantity ${maxQuantity}`)
  }
        

    }

    const handleCancel = () => {
        handleCloseClick();
    };

    const handleWorkOrderChange = (event, value, setFieldValue) => {
        setPartSel("");
        setSRSel("");
        setSRAisleSel("");
        setSRRowSel("");
        setSRBinSel("");
        setIssueItem({
            partId: null,
            stockRoomId: null,
            stockRoomRowId: null,
            stockRoomRowAisleId: null,
            stockRoomRowBinId: null,
            quantity: 0,
            unitCost: 0,
            lineCost: 0,
            issuedDate:getCurrentInTimeZone().dayjsObject,
            stockAisle:[],
            stockRow:[],
            stockBin:[],
            stockRoom:[]
        });
        setAddIssue([]);

        if (value !== null) {
            setFieldValue("workOrderId", value.id);
            setSelectedWorkOrder(value);
            setWOSel(value.code + " - " + value.workOrderName);

            if (partAssignType === "Assigned") {
                fetchWorkOrderParts(value.id);
            } else if (partAssignType === "Reserved") {
                fetchReservedParts(value.id);
            }
        } else {
            setFieldValue("workOrderId", null);
            setWOSel("");
            setSelectedWorkOrder(null);
            setWorkOrderParts([]);
            setReservedParts([]);
        }
    };

    const handlePartAssignTypeChange = (e) => {
        const newType = e.target.value;
        setPartAssignType(newType);

        setPartSel("");
        setSRSel("");
        setSRAisleSel("");
        setSRRowSel("");
        setSRBinSel("");
        setIssueItem({
            partId: null,
            stockRoomId: null,
            stockRoomRowId: null,
            stockRoomRowAisleId: null,
            stockRoomRowBinId: null,
            quantity: 0,
            unitCost: 0,
            lineCost: 0,
            issuedDate:getCurrentInTimeZone().dayjsObject,
            stockAisle:[],
            stockRow:[],
            stockBin:[],
            stockRoom:[]
        });
        setAddIssue([]);

        if (selectedWorkOrder) {
            if (newType === "Unassigned") {
                fetchPartall();
            } else 
                if (newType === "Reserved") {
                fetchReservedParts(selectedWorkOrder.id);
            }
        }
    };

    const handleStockRoom=async(value)=>{
        const getAisleLink=masterAPI["selectList"].aisleByPartAndRoom
        await axiosPrivate.get(`${getAisleLink}/${issueItem.partId}/${value.value}`).then(res=>{
            const storeStockRoom={
                ...issueItem,
                stockRoomId:value.value,

                stockRoomName:value.text,
                stockAisle:res.data
            }

         
            setIssueItem(storeStockRoom)
        }).catch(e=>{
            console.log(e,"error")
        })
    }
    const handleStockAisle=async(value)=>{
        const getRowLink=masterAPI["selectList"].rowByPartAndAisle
        await axiosPrivate.get(`${getRowLink}/${issueItem.partId}/${value.value}`).then(res=>{

            const storeStockRoom={
                ...issueItem,
                stockRoomRowAisleId:value.value,

                aisleName:value.text,
                stockRow:res.data
            }


            setIssueItem(storeStockRoom)
        }).catch(e=>{
            console.log(e,"error")
        })
    }
    const handleStockRow=async(value)=>{
        const getBinLink=masterAPI["selectList"].binByPartAndRow
        await axiosPrivate.get(`${getBinLink}/${issueItem.partId}/${value.value}`).then(res=>{
            const storeStockRoom={
                ...issueItem,
                stockRoomRowId:value.value,

                rowName:value.text,
                stockBin:res.data
            }


            setIssueItem(storeStockRoom)
        }).catch(e=>{
            console.log(e,"error")
        })
    }
    const handleStockBin=(value)=>{

        const storeStockRoom={
            ...issueItem,
            stockRoomRowBinId:value.value,

            binName:value.text

        }


        setIssueItem(storeStockRoom)

    }

    const handleIssueList=()=>{
        if(issueItem.quantity===0){
            toast.warn("Quantity must be greater than 0")
            return
        }else{
        const addlist=[...addIssue,{...issueItem,issuedDate:toUTC(issueItem.issuedDate).utcISOString}]
        console.log(addlist)
        setAddIssue(addlist)
        setIssueItem({
            partId: null,
            stockRoomId: null,
            stockRoomRowId: null,
            stockRoomRowAisleId: null,
            stockRoomRowBinId: null,
            quantity: 0,
            unitCost: 0,
            lineCost: 0,
            issuedDate:getCurrentInTimeZone().dayjsObject,
            stockAisle:[],
            stockRow:[],
            stockBin:[],
            stockRoom:[]
        })
        setPartSel("")
        setSRAisleSel("")
        setSRBinSel("")
        setSRRowSel("")
        setSRSel("")
        setMaxQuantity("")
    }
    }

    const handlePartEdit=(data)=>{
        console.log(data.row)
        const filterAddIssue=addIssue.filter((fil,i)=>i!==Number(data.row.id))

        console.log(filterAddIssue)

        setIssueItem({...data.row.original,issuedDate:fromUTC(data.row.original.issuedDate).dayjsObject})
        setSRSel(data.row.original.stockRoomName)
        setPartSel(data.row.original.partCode+"-"+data.row.original.partName)
        setSRAisleSel(data.row.original.aisleName)
        setSRRowSel(data.row.original.rowName)
        setSRBinSel(data.row.original.binName)
        setAddIssue(filterAddIssue)

    }



    const partColumn = [
        {
            Header: "Part",
            accessor: "partCode",
            Cell: ({ cell }) => {
                return (
                    <Typography
                        sx={{
                            color: "#0d6efd",
                            fontSize: "inherit",
                            fontWeight: 600,
                            cursor: "pointer",
                        }}
                    >
                        {cell.value+" - "+cell.row.original.partName}
                    </Typography>
                );
            },
        },
        {
            Header: "Stock Name",
            accessor: "stockRoomName",

        },
        {
            Header: "Aisle",
            accessor: "aisleName",
        },
        {
            Header: "Row",
            accessor: "rowName",
        },
        {
            Header: "Bin",
            accessor: "binName",
        },
        {
            Header: "Quantity",
            accessor: "quantity",
        },
        {
            Header: "Unit Cost",
            accessor: "unitCost",
            Cell: ({cell}) => (
                <>
                    {siteInfoDetail.currencySymbol}{cell.value}
                </>
            )},
        {
            Header: "Line Cost",
            accessor: "lineCost",
            Cell: ({cell}) => (
                <>
                    {siteInfoDetail.currencySymbol}{cell.value}
                </>
            )
        },
        {
            Header: "Issued Date",
            accessor: "issuedDate",

        },


        {
            Header:"Action",
            accessor:"partId",
            Cell:({cell})=>{
                return (
                    <>
                        <IconButton >
                            <EditOutlined
                                onClick={() => {
                                    handlePartEdit(cell);
                                }}
                                sx={{
                                    fontSize: color.masterEditDelButton,
                                    color: color.masterEditDelButtonColor,
                                }}
                            />
                        </IconButton>
                        <IconButton
                            onClick={() => {
                                deleteIssue(cell.row.original.partId);
                            }}
                        >
                            <DeleteOutlined

                                sx={{
                                    fontSize: color.masterEditDelButton,
                                    color: color.masterEditDelButtonColor,
                                }}
                            />
                        </IconButton>
                    </>
                )
            },
            disableFilters:true,
        }
    ];

    const deleteIssue=(id)=>{
        const delIssue=addIssue.filter(fil=>fil.partId!==id)
        setAddIssue(delIssue)
    }

    const getCurrentPartOptions = () => {
        switch(partAssignType) {
            case "Assigned":
                return workOrderParts;
            case "Reserved":
                return reservedParts;
            case "Unassigned":
            default:
                return partData;
        }
    };

    const getPartOptionLabel = (option) => {
        if (partAssignType === "Reserved") {
            return (option.partCode ? option.partCode + " - " : "") + option.partName || option;
        } else {
            return option.code + " - " + option.partName || option;
        }
    };

    const handlePartSelection = (value) => {
        if (value !== null) {
            switch(partAssignType) {
                case "Assigned":
                    handleAssignedPart(value);
                    setPartSel((value.code || "") + (value.code ? " - " : "") + value.partName);
                    break;
                case "Reserved":
                     setMaxQuantity(value.quantity)
                    handleReservedPart(value);
                    setPartSel((value.partCode || "") + (value.partCode ? " - " : "") + value.partName);
                    break;
                case "Unassigned":
                default:
                    handlePart(value);
                    setPartSel(value.code + " - " + value.partName);
                    break;
            }
        } else {
            setPartSel("");
            setIssueItem({
                ...issueItem,
                partId: null,
                stockRoomId: null,
                stockRoom: [],
            });
            setSRSel("");
        }
    };

    return (
        <Box sx={{ p: color.masterPageDialogPadding }}>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                }}
            >
                <Typography
                    sx={{
                        color: color.masterDialogTitleColor,
                        fontSize: color.masterDialogFontSize,
                    }}
                >
                    New Issue
                </Typography>
                <IconButton onClick={handleCancel}>
                    <Clear />
                </IconButton>
            </Box>
            <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
            <Formik initialValues={initialValue} onSubmit={onSubmit}>
                {({ setFieldValue, values }) => (
                    <Form>
                        <Grid container spacing={"1rem"}>
                            <Grid item xs={12} md={6}>
                                <Typography
                                    sx={{
                                        fontWeight: color.labelFontWeight,
                                        mb: color.labelmb,
                                        fontSize: color.labelFont,
                                        color: color.labelColor,
                                    }}
                                >
                                    Work Order
                                </Typography>
                                <Autocomplete
                                    value={selectedWorkOrder}
                                    inputValue={woSel}
                                    fullWidth
                                    filterOptions={filterOptions}
                                    loading={woData.length===0}
                                    options={woData}
                                    PaperComponent={CustomPaper}
                                    getOptionLabel={(option) =>
                                        option.code + " - " + option.workOrderName || option
                                    }
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    freeSolo
                                    onChange={(event, value) => {
                                        handleWorkOrderChange(event, value, setFieldValue);
                                    }}
                                    onInputChange={(event,newInputValue)=>{
                                        console.log(newInputValue)
                                        setWOSel(newInputValue)

                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            name="workOrderId"
                                            placeholder="Select Wo"
                                            variant="outlined"
                                            size="small"

                                            fullWidth
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <React.Fragment>
                                                        {woData.length===0 ? (
                                                            <CircularProgress color="inherit" size={20} />
                                                        ) : null}
                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography
                                    sx={{
                                        fontWeight: color.labelFontWeight,
                                        mb: color.labelmb,
                                        fontSize: color.labelFont,
                                        color: color.labelColor,
                                    }}
                                >
                                    Asset
                                </Typography>
                                <Autocomplete
                                    inputValue={assetSel}
                                    fullWidth
                                    filterOptions={filterOptions}
                                    loading={assetData.length===0}
                                    options={assetData}
                                    PaperComponent={CustomPaper}
                                    getOptionLabel={(option) =>
                                        option.code + " - " + option.assetName || option
                                    }
                                    freeSolo
                                    onChange={(event, value) => {
                                        console.log(value)
                                        if(value!==null){
                                            setFieldValue("assetId",value.id)
                                        }else{
                                            setAssetSel("")
                                        }

                                    }}
                                    onInputChange={(event,newInputValue)=>{
                                        console.log(newInputValue)
                                        setAssetSel(newInputValue)

                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            name="assetId"
                                            placeholder="Select Asset"
                                            variant="outlined"
                                            size="small"

                                            fullWidth
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <React.Fragment>
                                                        {assetData.length===0 ? (
                                                            <CircularProgress color="inherit" size={20} />
                                                        ) : null}
                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Typography
                                    sx={{
                                        fontWeight: color.labelFontWeight,
                                        mb: color.labelmb,
                                        fontSize: color.labelFont,
                                        color: color.labelColor,
                                    }}
                                >
                                    Transaction Date
                                </Typography>


                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoItem>
                                        <DatePicker
                                            readOnly
                                            format="DD/MM/YYYY hh:mm:ss A"
                                            value={values.issuedDate===null?null:dayjs(values.issuedDate)}

                                            slotProps={{
                                                textField: {
                                                    size: "small",

                                                    fullWidth: true,
                                                },
                                            }}
                                            fullWidth
                                            onChange={(newValue) => {
                                                console.log(newValue);
                                                if (newValue !== null) {
                                                    if (`${newValue.$d}` !== "Invalid Date") {
                                                        const dateFrom = getDateWithOutUTC(newValue)
                                                        setFieldValue("issuedDate",dateFrom)
                                                    }
                                                }
                                            }}
                                        />
                                    </DemoItem>
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography
                                    sx={{
                                        fontWeight: color.labelFontWeight,
                                        mb: color.labelmb,
                                        fontSize: color.labelFont,
                                        color: color.labelColor,
                                    }}
                                >
                                    Gl Credit Account
                                </Typography>
                                <Field
                                    as={TextField}
                                    size={"small"}
                                    type="text"
                                    name="glCreditAccount"
                                    placeholder="Enter GL Credit Account"
                                    fullWidth
                                    sx={{
                                        ".MuiInputBase-input": {
                                            "&::placeholder": {
                                                opacity: 1,
                                                color: color.placeholderColor,
                                                fontSize: "13px",
                                            },
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography
                                    sx={{
                                        fontWeight: color.labelFontWeight,
                                        mb: color.labelmb,
                                        fontSize: color.labelFont,
                                        color: color.labelColor,
                                    }}
                                >
                                    Gl Debit Account
                                </Typography>
                                <Field
                                    as={TextField}
                                    size={"small"}
                                    type="text"
                                    name="glDebitAccount"
                                    placeholder="Enter GL Debit Account"
                                    fullWidth
                                    sx={{
                                        ".MuiInputBase-input": {
                                            "&::placeholder": {
                                                opacity: 1,
                                                color: color.placeholderColor,
                                                fontSize: "13px",
                                            },
                                        },
                                    }}
                                />
                            </Grid>
                             <Grid item xs={12} md={6}>
                                            <Typography
                                              sx={{
                                                fontWeight: color.labelFontWeight,
                                                mb: color.labelmb,
                                                fontSize: color.labelFont,
                                                color: color.labelColor,
                                              }}
                                            >
                                            Issued To
                                            </Typography>
                                            <Autocomplete
                                              // value={remedySelect}
                                              inputValue={issuePerson}
                                              //value={causeInfo.id===null?null:causeInfo}
                                              fullWidth
                                              filterOptions={filterOptions}
                                              loading={personData.length===0}
                                              options={personData}
                                              PaperComponent={CustomPaper}
                                              getOptionLabel={(option) =>option.personName || option}
                                              
                                              freeSolo
                                              onChange={(event, value) => {
                                                console.log(value)
                                                if(value!==null){
                                                  // handleWo(value);
                                                  console.log(value)
                                                  setFieldValue("issuedToPersonId",value.id)
                                                  setIssuePerson(value.personName)
                                                }else{
                                                  setIssuePerson("")
                                                  setFieldValue("issuedToPersonId",null)
                                                }
                                               
                                              }}
                                              onInputChange={(event,newInputValue)=>{
                                                console.log(newInputValue)
                                                setIssuePerson(newInputValue)
                                                
                                              }}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  name="returnedById"
                                                  placeholder="Select Person"
                                                  //  onChange={handleChange}
                                                  variant="outlined"
                                                  size="small"
                                             
                                                  fullWidth
                                                  InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                      <React.Fragment>
                                                        {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                                                        {personData.length===0 ? (
                                                          <CircularProgress color="inherit" size={20} />
                                                        ) : null}
                                                        {params.InputProps.endAdornment}
                                                      </React.Fragment>
                                                    ),
                                                  }}
                                                />
                                              )}
                                            />
                                          </Grid>
                            <Grid item xs={12}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        width: "100%",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: color.masterDialogTitleColor,
                                            fontSize: color.masterDialogFontSize,
                                        }}
                                    >
                                        Create Issued Item
                                    </Typography>
                                    <IconButton
                                        sx={{backgroundColor:color.TableButtonColor}}
                                        onClick={handleIssueList}
                                    >
                                        <Add sx={{color:"white"}}/>
                                    </IconButton>
                                </Box>
                                <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
                            </Grid>

                            <Grid container item xs={12} spacing={"1rem"} >
                                <Grid item xs={12} md={4}>
                                    <Typography
                                        sx={{
                                            fontWeight: color.labelFontWeight,
                                            mb: color.labelmb,
                                            fontSize: color.labelFont,
                                            color: color.labelColor,
                                        }}
                                    >
                                        Part Assign Type
                                    </Typography>
                                    <Select
                                        size={"small"}
                                        type="text"
                                        name="partAssignType"
                                        value={partAssignType}
                                        fullWidth
                                        onChange={handlePartAssignTypeChange}
                                    >
                                        <MenuItem value="Unassigned">Unassigned</MenuItem>
                                        {/* <MenuItem value="Assigned">Assigned</MenuItem> */}
                                        <MenuItem value="Reserved">Reserved</MenuItem>
                                    </Select>
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Typography
                                        sx={{
                                            fontWeight: color.labelFontWeight,
                                            mb: color.labelmb,
                                            fontSize: color.labelFont,
                                            color: color.labelColor,
                                        }}
                                    >
                                        Part
                                    </Typography>
                                    <Autocomplete
                                        inputValue={partSelect}
                                        fullWidth
                                        filterOptions={filterOptions}
                                        loading={loadingParts && (partAssignType === "Assigned" || partAssignType === "Reserved")}
                                        options={getCurrentPartOptions()}
                                        PaperComponent={CustomPaper}
                                        getOptionLabel={getPartOptionLabel}
                                        disabled={
                                            (partAssignType === "Assigned" || partAssignType === "Reserved") && !selectedWorkOrder
                                        }
                                        freeSolo
                                        onChange={(event, value) => {
                                            handlePartSelection(value);
                                        }}
                                        onInputChange={(event,newInputValue)=>{
                                            console.log(newInputValue)
                                            setPartSel(newInputValue)

                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                name="partId"
                                                placeholder={
                                                    (partAssignType === "Assigned" || partAssignType === "Reserved") && !selectedWorkOrder
                                                        ? "Select Work Order First"
                                                        : "Select Part"
                                                }
                                                variant="outlined"
                                                size="small"

                                                fullWidth
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <React.Fragment>
                                                            {loadingParts && (partAssignType === "Assigned" || partAssignType === "Reserved") ? (
                                                                <CircularProgress color="inherit" size={20} />
                                                            ) : null}
                                                            {params.InputProps.endAdornment}
                                                        </React.Fragment>
                                                    ),
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Typography
                                        sx={{
                                            fontWeight: color.labelFontWeight,
                                            mb: color.labelmb,
                                            fontSize: color.labelFont,
                                            color: color.labelColor,
                                        }}
                                    >
                                        Stock Room
                                    </Typography>
                                    <Autocomplete
                                        inputValue={srSelect}
                                        fullWidth
                                        filterOptions={filterOptions}
                                        options={issueItem.stockRoom}
                                        PaperComponent={CustomPaper}
                                        getOptionLabel={(option) =>
                                            option.text || option
                                        }
                                        disabled={partAssignType === "Reserved"}
                                        freeSolo
                                        onChange={(event, value) => {
                                            console.log(value)
                                            if(value!==null){
                                                handleStockRoom(value);
                                            }else{
                                                setSRSel("")
                                            }

                                        }}
                                        onInputChange={(event,newInputValue)=>{
                                            console.log(newInputValue)
                                            setSRSel(newInputValue)

                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                name="stockRoomId"
                                                placeholder={partAssignType === "Reserved" ? "Auto-Selected (Reserved)" : "Select Stock Room"}
                                                variant="outlined"
                                                size="small"

                                                fullWidth
                                                InputProps={{
                                                    ...params.InputProps,
                                                }}
                                            />
                                        )}
                                    />

                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Typography
                                        sx={{
                                            fontWeight: color.labelFontWeight,
                                            mb: color.labelmb,
                                            fontSize: color.labelFont,
                                            color: color.labelColor,
                                        }}
                                    >
                                        Aisle
                                    </Typography>
                                    <Autocomplete
                                        inputValue={srAisleSelect}
                                        fullWidth
                                        filterOptions={filterOptions}
                                        options={issueItem.stockAisle}
                                        PaperComponent={CustomPaper}
                                        getOptionLabel={(option) =>
                                            option.text || option
                                        }
                                        freeSolo
                                        onChange={(event, value) => {
                                            console.log(value)
                                            if(value!==null){
                                                handleStockAisle(value);
                                            }else{
                                                setSRAisleSel("")
                                            }

                                        }}
                                        onInputChange={(event,newInputValue)=>{
                                            console.log(newInputValue)
                                            setSRAisleSel(newInputValue)

                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                name="stockRoomRowAisleId"
                                                placeholder="Select Aisle"
                                                variant="outlined"
                                                size="small"

                                                fullWidth
                                                InputProps={{
                                                    ...params.InputProps,
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Typography
                                        sx={{
                                            fontWeight: color.labelFontWeight,
                                            mb: color.labelmb,
                                            fontSize: color.labelFont,
                                            color: color.labelColor,
                                        }}
                                    >
                                        Row
                                    </Typography>
                                    <Autocomplete
                                        inputValue={srRowSelect}
                                        fullWidth
                                        filterOptions={filterOptions}
                                        options={issueItem.stockRow}
                                        PaperComponent={CustomPaper}
                                        getOptionLabel={(option) =>
                                            option.text || option
                                        }
                                        freeSolo
                                        onChange={(event, value) => {
                                            console.log(value)
                                            if(value!==null){
                                                handleStockRow(value);
                                            }else{
                                                setSRRowSel("")
                                            }

                                        }}
                                        onInputChange={(event,newInputValue)=>{
                                            console.log(newInputValue)
                                            setSRRowSel(newInputValue)

                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                name="stockRoomRowId"
                                                placeholder="Select Row"
                                                variant="outlined"
                                                size="small"

                                                fullWidth
                                                InputProps={{
                                                    ...params.InputProps,
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Typography
                                        sx={{
                                            fontWeight: color.labelFontWeight,
                                            mb: color.labelmb,
                                            fontSize: color.labelFont,
                                            color: color.labelColor,
                                        }}
                                    >
                                        Bin
                                    </Typography>
                                    <Autocomplete
                                        inputValue={srBinSelect}
                                        fullWidth
                                        filterOptions={filterOptions}
                                        options={issueItem.stockBin}
                                        PaperComponent={CustomPaper}
                                        getOptionLabel={(option) =>
                                            option.text || option
                                        }
                                        freeSolo
                                        onChange={(event, value) => {
                                            console.log(value)
                                            if(value!==null){
                                                handleStockBin(value);
                                            }else{
                                                setSRBinSel("")
                                            }

                                        }}
                                        onInputChange={(event,newInputValue)=>{
                                            console.log(newInputValue)
                                            setSRBinSel(newInputValue)

                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                name="stockRoomRowBinId"
                                                placeholder="Select Bin"
                                                variant="outlined"
                                                size="small"

                                                fullWidth
                                                InputProps={{
                                                    ...params.InputProps,
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Typography
                                        sx={{
                                            fontWeight: color.labelFontWeight,
                                            mb: color.labelmb,
                                            fontSize: color.labelFont,
                                            color: color.labelColor,
                                        }}
                                    >
                                        Quantity
                                    </Typography>
                                    <TextField
                                        size={"small"}
                                        type="number"
                                        name="quantity"
                                        value={issueItem.quantity}
                                        placeholder="Enter Quantity"
                                        fullWidth
                                        onChange={handleAddIssue}
                                    InputProps={{
                                              endAdornment: <InputAdornment position="end">{partAssignType ==="Reserved"?`Max: ${maxQuantity}`:null}</InputAdornment>,
                                            }}

                                        sx={{
                                            ".MuiInputBase-input": {
                                                "&::placeholder": {
                                                    opacity: 1,
                                                    color: color.placeholderColor,
                                                    fontSize: "13px",
                                                },
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Typography
                                        sx={{
                                            fontWeight: color.labelFontWeight,
                                            mb: color.labelmb,
                                            fontSize: color.labelFont,
                                            color: color.labelColor,
                                        }}
                                    >
                                        Unit Cost
                                    </Typography>
                                    <TextField
                                        size={"small"}
                                        type="number"
                                        name="unitCost"
                                        value={issueItem.unitCost}
                                        placeholder="Enter Unit Cost"
                                        fullWidth
                                        onChange={handleAddIssue}
                                        sx={{
                                            ".MuiInputBase-input": {
                                                "&::placeholder": {
                                                    opacity: 1,
                                                    color: color.placeholderColor,
                                                    fontSize: "13px",
                                                },
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Typography
                                        sx={{
                                            fontWeight: color.labelFontWeight,
                                            mb: color.labelmb,
                                            fontSize: color.labelFont,
                                            color: color.labelColor,
                                        }}
                                    >
                                        Line Cost
                                    </Typography>
                                    <TextField
                                        size={"small"}
                                        type="number"
                                        name="lineCost"
                                        value={issueItem.lineCost}
                                        placeholder="Enter Line Cost"
                                        fullWidth
                                        onChange={handleAddIssue}
                                        sx={{
                                            ".MuiInputBase-input": {
                                                "&::placeholder": {
                                                    opacity: 1,
                                                    color: color.placeholderColor,
                                                    fontSize: "13px",
                                                },
                                            },
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Typography
                                        sx={{
                                            fontWeight: color.labelFontWeight,
                                            mb: color.labelmb,
                                            fontSize: color.labelFont,
                                            color: color.labelColor,
                                        }}
                                    >
                                        Issued Date
                                    </Typography>

                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoItem>
                                            <DatePicker

                                                format="DD/MM/YYYY"
                                                value={issueItem.issuedDate===null?null:dayjs(issueItem.issuedDate)}

                                                slotProps={{
                                                    textField: {
                                                        size: "small",

                                                        fullWidth: true,
                                                    },
                                                }}
                                                fullWidth
                                                onChange={(newValue) => {
                                                    console.log(newValue);
                                                    if (newValue !== null) {
                                                        if (`${newValue.$d}` !== "Invalid Date") {
                                                            const dateFrom = getDateWithOutUTC(newValue)
                                                            const storeDate={
                                                                ...issueItem,
                                                                issuedDate:dateFrom
                                                            }
                                                            setIssueItem(storeDate)
                                                        }
                                                    }
                                                }}
                                            />
                                        </DemoItem>
                                    </LocalizationProvider>
                                </Grid>

                            </Grid>
                            <Grid item xs={12}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        width: "100%",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: color.masterDialogTitleColor,
                                            fontSize: color.masterDialogFontSize,
                                        }}
                                    >
                                        Issue Item List
                                    </Typography>

                                </Box>
                                <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
                            </Grid>
                            <Grid item xs={12}>
                                <NormalTable
                                    data={addIssue}
                                    columns={partColumn}
                                    filt={true}
                                />
                            </Grid>
                            <Grid
                                container
                                item
                                xs={12}
                                justifyContent={"flex-end"}
                                gap="1rem"
                            >
                                <Button
                                    onClick={handleCancel}
                                    variant="contained"
                                    sx={{
                                        backgroundColor: color.TableCancelButton,
                                        textTransform: "none",
                                        color: color.CancelTextColor,
                                        ":hover": {
                                            backgroundColor: color.TableCancelButton,
                                            textTransform: "none",
                                            color: color.CancelTextColor,
                                        },
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type={"submit"}
                                    variant="contained"
                                    disabled={loading||addIssue.length===0}
                                    sx={{
                                        textTransform: "none",
                                        backgroundColor: loading
                                            ? "default"
                                            : color.TableButtonColor,
                                        "&:hover": {
                                            backgroundColor: loading
                                                ? "default"
                                                : color.buttonDisable,
                                        },
                                    }}
                                >
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </Box>
    );
};

export default IssueModal;

